module.exports = __webpack_public_path__ + "media/logo/logo_rhizome-3ff9fc27.png";